import { useQuery } from '@apollo/client';

import { EVENT_BEDROOMS } from '../graphql/query/eventBedroomsQuery.graphql';

export const useEventBedroomsQuery = (eventId: string | null) => {
  return useQuery(EVENT_BEDROOMS, {
    skip: eventId === null,
    variables: { eventId: eventId ?? '' },
  });
};
